module.exports = __webpack_public_path__ + "static/media/impresjanet logo.de75ea96.png";